import ready from '../utils/ready';

const ALL_CATEGORIES_SE = 'Alla kategorier';
const ALL_CATEGORIES_NO = 'Alle kategorier';
const ACTIVE_BUTTON_CLASS = 'toggle-list__btn--is-active';

const reset = (buttons: NodeListOf<HTMLButtonElement>, list: Element | null) => {
  buttons.forEach((subBtns, subBtnIndex) => {
    if (subBtnIndex !== 0) {
      subBtns.classList.remove(ACTIVE_BUTTON_CLASS);
    } else {
      subBtns.classList.add(ACTIVE_BUTTON_CLASS);
    }
  });

  list?.querySelectorAll('.grid__item').forEach((li) => {
    li.removeAttribute('hidden');
  });
};

const campaignHandler = () => {
  document
    .querySelectorAll('[data-module-type="campaigns-dynamic"], [data-module-type="campaigns-list"]')
    .forEach((module) => {
      const filters = module.querySelector('[data-campaigns-dynamic-filter]');
      const list = module.querySelector('[data-campaigns-dynamic-list]');
      const items = list?.querySelectorAll('.grid__item');

      if (filters) {
        const buttons = filters.querySelectorAll('button');
        buttons.forEach((btn, btnIndex) =>
          btn.addEventListener('click', () => {
            if (btnIndex === 0) {
              reset(buttons, list);
            } else {
              if (btn.classList.contains(ACTIVE_BUTTON_CLASS)) {
                btn.classList.remove(ACTIVE_BUTTON_CLASS);
              } else {
                btn.classList.add(ACTIVE_BUTTON_CLASS);
              }

              const activeFilters: string[] = [];
              buttons.forEach((b) => {
                if (b.classList.contains(ACTIVE_BUTTON_CLASS)) {
                  activeFilters.push(b.innerText.trim());
                }
              });

              const filterValues = [ALL_CATEGORIES_SE, ALL_CATEGORIES_NO];
              if (filterValues.some((value) => activeFilters.includes(value))) {
                activeFilters.splice(0, 1);
                buttons[0].classList.remove(ACTIVE_BUTTON_CLASS);
              } else if (
                !buttons[0].classList.contains(ACTIVE_BUTTON_CLASS) &&
                !activeFilters.length
              ) {
                reset(buttons, list);
                return;
              }

              list?.querySelectorAll('.campaign-card').forEach((gridItem, index) => {
                const dataTags = gridItem.getAttribute('data-tag');
                const itemCategories = dataTags ? dataTags.split(',').map((tag) => tag.trim()) : [];
                if (itemCategories.find((itemCategory) => activeFilters.includes(itemCategory))) {
                  items?.[index]?.removeAttribute('hidden');
                } else {
                  items?.[index]?.setAttribute('hidden', '');
                }
              });
            }
          })
        );
      }
    });
};

ready(campaignHandler);
